import { FC } from "react";

interface Props {
  title: string;
  icon: React.ReactNode;
  onClick: () => void;
}
const MenuItem: FC<Props> = ({ title, icon, onClick }) => {
  return (
    <div
      className="px-3.5   flex-row-reverse py-2  flex gap-x-1 items-center cursor-pointer hover:bg-fds-secondary"
      onClick={onClick}
    >
      {icon}
      <span className="title-sm">{title}</span>
    </div>
  );
};

export default MenuItem;
